import React, { useState, useEffect } from 'react'
import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Select,
  Button,
  HStack,
  Spacer,
  useDisclosure,
  Collapse,
  IconButton,
  Divider,
  Stack,
  Switch,
} from '@chakra-ui/react'
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons'

// Lista fixa de fornecedores permitidos com nomes mais descritivos
const FORNECEDORES_PERMITIDOS = [
  { id: 24, nome: 'XBZ Importadora' },
  { id: 32, nome: 'Asia Link Trading' },
  { id: 155, nome: 'Spot Brindes' },
]

function FiltrosProdutos({ filtros, isLoading, onChangeFiltro, onBuscar, onAbrirModalStatus, onAbrirModalAdicionar }) {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true })

  return (
    <Box bg="white" p={4} borderRadius="md" shadow="sm" mb={4}>
      <Flex align="center" mb={isOpen ? 4 : 0}>
        <Box fontWeight="medium">Filtros</Box>
        <IconButton
          icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
          variant="ghost"
          size="sm"
          onClick={onToggle}
          aria-label={isOpen ? 'Fechar filtros' : 'Abrir filtros'}
          ml={2}
        />
        <Spacer />
        <HStack spacing={2}>
          <Button colorScheme="blue" size="sm" onClick={onBuscar} isLoading={isLoading} loadingText="Buscando..." variant="outline">
            Buscar
          </Button>
          <Button size="sm" colorScheme="teal" onClick={onAbrirModalStatus} isDisabled={isLoading}>
            Ver Status
          </Button>
          <Button size="sm" colorScheme="green" onClick={onAbrirModalAdicionar} isDisabled={isLoading}>
            Adicionar Produtos
          </Button>
        </HStack>
      </Flex>

      <Collapse in={isOpen} animateOpacity>
        <Divider mb={4} />
        <Stack direction={{ base: 'column', md: 'row' }} spacing={4} align={{ base: 'stretch', md: 'flex-end' }} wrap="wrap">
          <FormControl minW="200px" maxW="300px">
            <FormLabel fontSize="sm" mb={1}>
              Fornecedor
            </FormLabel>
            <Select
              size="sm"
              value={filtros.fornecedor}
              onChange={(e) => onChangeFiltro('fornecedor', e.target.value)}
              isDisabled={isLoading}
              placeholder="Todos os fornecedores"
            >
              {FORNECEDORES_PERMITIDOS.map((fornecedor) => (
                <option key={fornecedor.id} value={fornecedor.id}>
                  {fornecedor.nome}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl minW="180px" maxW="250px">
            <FormLabel fontSize="sm" mb={1}>
              Status Pendente
            </FormLabel>
            <Select
              size="sm"
              value={filtros.pendente}
              onChange={(e) => onChangeFiltro('pendente', e.target.value)}
              isDisabled={isLoading}
              placeholder="Todos os produtos"
            >
              <option value="link">Link Pendente</option>
              <option value="foto">Foto Pendente</option>
              <option value="cadastro">Cadastro Pendente</option>
              <option value="site">Site Pendente</option>
              <option value="concluido">Concluídos</option>
            </Select>
          </FormControl>

          <FormControl minW="180px" maxW="250px">
            <FormLabel fontSize="sm" mb={1}>
              Filtrar por
            </FormLabel>
            <Select size="sm" value={filtros.filtrar_por} onChange={(e) => onChangeFiltro('filtrar_por', e.target.value)} isDisabled={isLoading}>
              <option value="dt_api">Data da API</option>
              <option value="dt_cadastro">Data de Cadastro</option>
              <option value="dt_site">Data do Site</option>
            </Select>
          </FormControl>

          <FormControl minW="180px" maxW="250px">
            <FormLabel fontSize="sm" mb={1}>
              Ordenação
            </FormLabel>
            <Select size="sm" value={filtros.ordenacao} onChange={(e) => onChangeFiltro('ordenacao', e.target.value)} isDisabled={isLoading}>
              <option value="desc">Decrescente</option>
              <option value="asc">Crescente</option>
            </Select>
          </FormControl>

          <FormControl display="flex" alignItems="center" minW="180px" py={1}>
            <Switch
              id="ver-excluidos"
              isChecked={filtros.excluido === 'S'}
              onChange={(e) => onChangeFiltro('excluido', e.target.checked ? 'S' : '')}
              colorScheme="red"
              size="sm"
              mr={2}
            />
            <FormLabel htmlFor="ver-excluidos" mb="0" fontSize="sm">
              Ver produtos excluídos
            </FormLabel>
          </FormControl>
        </Stack>
      </Collapse>
    </Box>
  )
}

export default FiltrosProdutos
